angular.module("vendor")
.controller("ImportSequenceModalController", function(
    $rootScope, $scope, FormError, close, ProductSequenceService, ProductOrderSequenceService, FlashBag,
    gettextCatalog
) {
    $scope.sequences = ProductSequenceService.query();
    $scope.selectedSequenceId = null;
    $scope.service = ProductOrderSequenceService;
    var _this = this

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    $scope.importData = function(data) {
        if ($scope.selectedSequenceId) {
            data.append("sequence_id", $scope.selectedSequenceId);
        }
        return ProductOrderSequenceService.importData(data).$promise;
    };

    this.importCallBack = function() {
        FlashBag.info(gettextCatalog.getString("The import will begin shortly. You'll receive an email when the process will be done."));
        _this.close();
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/sequence/import-sequence.modal.js
// module id = 896
// module chunks = 0